// Shared by the contact form and its API route, so the allowed values can never drift apart.
export const BUDGETS: Array<string> = [
    "Under €25k",
    "€25k to €75k",
    "€75k to €150k",
    "Over €150k"
]

export const CONTACT_LIMITS = {
    name: 120,
    email: 254,
    company: 120,
    message: 5000,
    minMessage: 10
}
